import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { vpsOciActions } from '@/redux/modules/productDetail/vpsOci';
import * as Styles from './ProductSnapshotsPage.styles';

const ProductSnapshotsPage = () => {
  const vpsOci = useSelector(state => state.vpsOci);
  const dispatch = useDispatch();

  const { id: hostingId } = useParams();

  useEffect(() => {
    dispatch(vpsOciActions.data.get({ hostingId }));
  }, [dispatch, hostingId]);
  useEffect(() => {
    // MOCK TEMPORARIA PARA TESTES
    if (hostingId !== null) {
      console.log({ vpsOci: vpsOci.data });
    }
  }, [vpsOci]);

  return (
    <Styles.Container>
      <Styles.Row>
        Página do Snapshot
      </Styles.Row>
    </Styles.Container>
  );
};

export default ProductSnapshotsPage;
